import React from 'react';
import { sentenceCase } from 'change-case';
import { Link } from 'react-router-dom';
import { Row, Col } from 'antd';
import { StackedJob as StackedJobType } from '../../types/Job';

interface StackedJobInterface {
    job: Omit<StackedJobType, 'deliveries'>;
}

const StackedJob: React.FC<StackedJobInterface> = (props: StackedJobInterface): React.ReactElement => {
    const {
        job: { id, createdAt, pickupAt, dropoffAt, assignmentCode },
    } = props;

    const detailProps: { key: string; value: any }[] = [
        { key: 'pickupAt', value: pickupAt },
        { key: 'dropoffAt', value: dropoffAt },
        { key: 'assignmentCode', value: assignmentCode },
    ];

    return (
        <div>
            <Row gutter={24} className="bg-white justify-content-between border-bottom mb-2">
                <Col span={12} className="d-flex align-items-center">
                    <strong>Job Id: </strong>
                    <Link to={`/admin/jobs/detail/${id}`} title="View detail" id={`link-job-detail__${id}`}>
                        {id}
                    </Link>
                </Col>
                <Col span={12} className="text-secondary text-right">
                    <small>
                        <strong>Created at:</strong>
                        <br />
                        {createdAt}
                    </small>
                </Col>
            </Row>
            {detailProps.map((prop) => (
                <Row key={prop.key}>
                    <Col span={12}>{`${sentenceCase(prop.key)}:`}</Col>
                    <Col span={12} className="text-secondary">
                        {prop.value || '-'}
                    </Col>
                </Row>
            ))}
        </div>
    );
};

export default StackedJob;
